<template>
  <base-container>
    <ArtisanGrid ref="msgRecord" metaKey="OpMsgRecord"> </ArtisanGrid>
  </base-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style>
</style>
